// GA4（gtag.js）を読み込むかどうかの判定。
//
// 測定IDは streams応答の `meta.gtag` から来るが、**meta ごと存在しない応答がある**。
// エッジ配信でD1エラーが起きたときの空応答（storeeel-proxy-gate の
// EDGE_ORIGIN_FALLBACK=false、`{"data":[],"meta":{}}`）がそれにあたる。
//
// 測定IDが取れないときは読み込みを諦める。判定せずに読みに行くと
// `gtag/js?id=undefined` を取得しようとしてしまうため。
export const shouldLoadGtag = ({ gtagId, hasGtag, isPreview }) =>
  Boolean(gtagId) && !hasGtag && !isPreview;
